import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import React from "react";
import DefaultPage from "./default-page";

import "./impressum.css";

export default function Impressum() {
  return (
    <DefaultPage>
      <div className="impressum">
        <h2 align="center">Impressum</h2>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Paper className="impressumPaper">
            <p align="center">
              <Typography variant="h5">
                Schanzer Gemeinschaft Ingolstadt e.V.
              </Typography>
              <Typography>vorstand@sgi-ev.de</Typography>

              <br />

              <Typography variant="h6">Vertreten durch:</Typography>
              <Typography>1. Vorsitzender: Tobias Böth</Typography>
              <Typography>2. Vorsitzender: Robert Moser</Typography>
              <Typography>Kassenwart: Dr. Fabian Mierisch</Typography>
              <br />
              <br />
              <br />
              <br />
              <br />
            </p>
            <Divider />
            <Typography variant="body">
              Software Version: {process.env.REACT_APP_VERSION}
            </Typography>
          </Paper>
        </Box>
        <br />
      </div>
    </DefaultPage>
  );
}
